import NamedStorage from "./NamedStorage";

export default class StoryStorage {
  private mStorage: NamedStorage;
  constructor() {
    this.mStorage = new NamedStorage("Story");
  }

  public GetMoney(): number {
    return this.mStorage.GetNumber("Money");
  }
  public AddMoney(gold: number) {
    const money = this.GetMoney();
    const totalMoney = money + gold;
    return this.mStorage.Store("Money", totalMoney.toString());
  }
  public RemoveMoney(gold: number) {
    const money = this.GetMoney();
    const totalMoney = Math.max(0, money - gold);
    return this.mStorage.Store("Money", totalMoney.toString());
  }
  public SetMoney(gold: number) {
    return this.mStorage.Store("Money", gold.toString());
  }

  public GetExp() {
    return this.mStorage.GetNumber("Exp");
  }
  public AddExp(exp: number) {
    const currExp = this.GetExp();
    const totalExp = currExp + exp;
    return this.mStorage.Store("Exp", totalExp.toString());
  }
  public RemoveExp(exp: number) {
    const currExp = this.GetExp();
    const totalExp = currExp - exp;
    return this.mStorage.Store("Exp", totalExp.toString());
  }
  public SetExp(exp: number) {
    return this.mStorage.Store("Exp", exp.toString());
  }
}
